import { Box, Text, Flex, Stack } from "@chakra-ui/react";
import { useRef } from "react";
import { trackEcommerceEvent } from "utils/tracking";
import { useElementIntersectionOnce } from "hooks";
import { useGetViewItemTrackingEvent } from "modules/storyblok/components/AhPlusPricingPlans/trackingUtils";
import PlanBox from "modules/experiments/AhPlusPricingPlans/PlanBox";

import {
  usePricingPlanDetailsConfig,
  CHOOSE_PRODUCT_ESSENTIAL,
  CHOOSE_PRODUCT_COMPLETE,
  ESSENTIAL_GA4_ECOMMERCE_EVENT,
  COMPLETE_GA4_ECOMMERCE_EVENT,
} from "modules/experiments/AhPlusPricingPlans/config";

import { PRICING_PLANS_ANCHOR } from "modules/storyblok/components/AhPlusPricingPlans/config";

import type { AhPlusPricingPlansProps } from "./AhPlusPricingPlans.d";

const AhPlusPricingPlans = ({ pushConversionEvent }: AhPlusPricingPlansProps) => {
  const { essential: essentialPlan, complete: completePlan } = usePricingPlanDetailsConfig();
  const viewItemTrackingEvent = useGetViewItemTrackingEvent();
  const sectionRef = useRef<HTMLDivElement>(null);
  const trackingEventHandler = () => trackEcommerceEvent(viewItemTrackingEvent);
  useElementIntersectionOnce(sectionRef, trackingEventHandler);

  return (
    <Box bg="primary.900" py={24} id={PRICING_PLANS_ANCHOR}>
      <Box px={4}>
        <Stack
          spacing={{ base: 8, md: 4, lg: 8 }}
          direction={{ base: "column", md: "row" }}
          justify="center"
          align="stretch"
          ref={sectionRef}
        >
          <Flex width={{ base: "100%", md: "50%" }} maxWidth="400px" alignSelf={{ base: "center", md: "stretch" }}>
            <PlanBox
              planDetails={essentialPlan}
              pushConversionEvent={pushConversionEvent}
              events={{
                gaEvent: CHOOSE_PRODUCT_COMPLETE,
                ga4ETracking: ESSENTIAL_GA4_ECOMMERCE_EVENT,
              }}
            />
          </Flex>
          <Flex width={{ base: "100%", md: "50%" }} maxWidth="400px" alignSelf={{ base: "center", md: "stretch" }}>
            <PlanBox
              planDetails={completePlan}
              pushConversionEvent={pushConversionEvent}
              events={{
                gaEvent: CHOOSE_PRODUCT_ESSENTIAL,
                ga4ETracking: COMPLETE_GA4_ECOMMERCE_EVENT,
              }}
            />
          </Flex>
        </Stack>
        <Text px={8} color="white" fontSize="md" textAlign="center" mt={{ base: 12, md: 10 }}>
          No matter where you’re flying. No matter the ticket price or airline.
        </Text>
      </Box>
    </Box>
  );
};

export default AhPlusPricingPlans;
